import { Api } from "@/utils/Api";
import { env } from "@/config/env";
import { AxiosInstance } from "axios";
import { UserStorage } from "@/storage/UserStorage";
import { captureApiError } from "./sentry";

const setupRainInterceptors = (client: AxiosInstance) => {
	client.interceptors.request.use(config => {
		const token = UserStorage.getToken();
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	});

	client.interceptors.response.use(
		response => response,
		error => {
			if (error?.response?.status === 500) {
				captureApiError("Rain api", error);
			}
			if (error?.response?.status === 401) {
				UserStorage.removeToken();
				window.location.href = "/login";
			}
			return Promise.reject(error);
		},
	);
};

export const rainApi = new Api(env.RAIN_API_URL || "", {}, setupRainInterceptors);
